import React, { useState, useEffect } from 'react';

interface DurationFieldProps {
  id: string;
  name: string;
  label: string;
  defaultValue?: number;
  required?: boolean;
  disabled?: boolean;
  className?: string;
  onChange?: (value: number) => void;
}

const DurationField: React.FC<DurationFieldProps> = ({
  id,
  name,
  label,
  defaultValue,
  required = false,
  disabled = false,
  className,
  onChange
}) => {
  const [displayValue, setDisplayValue] = useState<string>('');
  
  // Formater la valeur initiale
  useEffect(() => {
    if (defaultValue !== undefined) {
      formatDurationDisplay(defaultValue);
    }
  }, [defaultValue]);
  
  // Formater la durée pour l'affichage (minutes -> heures si nécessaire)
  const formatDurationDisplay = (minutes: number) => {
    if (minutes >= 60) {
      const hours = Math.floor(minutes / 60);
      const remainingMinutes = minutes % 60;
      
      if (remainingMinutes === 0) {
        setDisplayValue(`${hours}h`);
      } else {
        setDisplayValue(`${hours}h${remainingMinutes}`);
      }
    } else {
      setDisplayValue(`${minutes} min`);
    }
  };
  
  // Gérer le changement de valeur
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = parseInt(e.target.value, 10);
    if (!isNaN(value)) {
      // Arrondir à un multiple de 5
      const roundedValue = Math.round(value / 5) * 5;
      formatDurationDisplay(roundedValue);
      
      if (onChange) {
        onChange(roundedValue);
      }
    }
  };
  
  return (
    <div className={className}>
      <label htmlFor={id} className="block text-sm font-medium mb-1">
        {label}{required && <span className="text-red-500 ml-1">*</span>}
      </label>
      
      <div className="flex items-center">
        <input
          type="range"
          id={id}
          name={name}
          min="5"
          max="240"
          step="5"
          defaultValue={defaultValue || 30}
          className="w-full mr-4"
          disabled={disabled}
          onChange={handleChange}
        />
        <div className="w-20 text-center font-medium">{displayValue || '30 min'}</div>
      </div>
    </div>
  );
};

export default DurationField;
